import React from 'react';
import ServicePage from '../components/ServicePage';
import heroBillede from '../images/Fundamenter.jpg';

function Fundamenter() {
  return (
    <ServicePage
      slug="fundamenter"
      path="/fundamenter"
      navn="Fundamenter"
      seo={{
        title: 'Fundamenter & betonarbejde i Holbæk | JBC Entreprenøren',
        description: 'Vi støber solide betonfundamenter i Holbæk, Roskilde og på hele Sjælland – til tilbygninger, carporte, garager og terrasser. Få et gratis tilbud.',
        image: 'https://jbcentreprenoeren.dk/images/og-fundamenter.jpg',
        serviceName: 'Fundamenter og betonarbejde',
      }}
      hero={{
        titel: 'Fundamenter og betonarbejde',
        tekst: 'Vi støber solide fundamenter og udfører betonarbejde for kunder på hele Sjælland.',
        cta: 'Få tilbud på fundamenter',
        billede: heroBillede,
        billedeAlt: 'Støbt fundament set fra luften',
      }}
      intro={{
        titel: 'Et stærkt fundament for dit byggeri',
        tekst: [
          'JBC Entreprenøren laver fundamenter i Holbæk, Roskilde, Mørkøv og resten af Sjælland.',
          'Vi sørger for, at alt bliver gjort ordentligt, så du får en stærk og pålidelig fundamentløsning, der holder i mange år.',
        ],
      }}
      ydelser={{
        titel: 'Vores fundamenttjenester',
        punkter: [
          'Støbning af betonfundamenter',
          'Armering og jernbinding',
          'Fundamenter til tilbygninger',
          'Carport- og garagefundamenter',
          'Terrasse- og udestuefundamenter',
        ],
      }}
      fordele={{
        titel: 'Derfor vælger kunder os til fundamenter',
        punkter: [
          'Lokalt kendskab til jordbundsforhold i Nordvestsjælland',
          'Erfaring med alle typer fundamenter',
          'Kvalitetsmaterialer og solid udførelse',
          'Hurtig sagsbehandling',
          'Garanti på arbejdet',
        ],
      }}
      kontaktTekst="Skal du have støbt fundamenter i Holbæk, Tølløse eller andre steder på Sjælland? Vi hjælper gerne med dit projekt."
    />
  );
}

export default Fundamenter;
